<template>
  <div class="modal" @click="closeModal" ref="modal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h3>{{ attributeGroup.attributes.length }} Διαθέσιμες Παραλλαγές </h3>
        <span class="close" @click="closeModal">&times;</span>
      </div>
      <div class="modal-body">
        <button
          v-for="attr in attributeGroup.attributes"
          :key="attr.attributeId"
          :style="btnStyle(attr.attributeDisplayValue)"
          :class="selected === attr.attributeId ? 'selected' : ''"
          @click="setSelected(attr.attributeId)">
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'AttributesImagesModal',
  props: {
    attributeGroup: {
      type: Object,
      required: true
    }
  },
  setup(props, { emit }) {
    const modalRef = ref(null);
    const selected = ref(null);
    const closeModal = () => {
      emit('close-modal');
    };

    function setSelected(attributeId) {
      selected.value = attributeId;
      emit('attribute-clicked', attributeId);
    }
    const btnStyle = (attributeDisplayValue) => {
      return {
        backgroundImage: `url('/files/product_attributes/${attributeDisplayValue}')`
      };
    };

    return {
      modalRef,
      closeModal,
      setSelected,
      btnStyle,
      selected
    };
  }
}
</script>

<style scoped>

.modal {
  display: block;
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow-y: auto;
}

.modal-content {
  background-color: #fefefe;
  margin: 18% auto;
  padding: 20px;
  border: 1px solid #888;
  border-radius: 5px;
  width: 80%;
  max-width: 600px;
  @media screen and (max-width:1000px){
    margin: 40% auto;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
}

.close {
  cursor: pointer;
  color: #aaa;
  font-size: 28px;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.modal-body {
  display: flex;
  padding: 20px 0;
  flex-flow: wrap;
  gap: 15px;
  justify-content: center;
}

.selected {
  border: 2px solid var(--prime2);
}
</style>
